





























































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import Big from "big.js";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() userId!: number;

  @Prop() t!: number;

  @Prop() field!: string;

  @Prop() depositCate!: number;

  @Prop() money!: number;

  title = "";

  mounted() {
    switch (this.field) {
      case "sys_frozen_money":
        this.title = "系统冻结金额";
        break;
      case "real_sys_frozen_money":
        this.title = "实际冻结";
        break;
      case "deposit":
        this.title = "保证金";
        break;
      default:
        this.title = "";
    }
  }

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        // console.log(fieldValues);

        if (Number(fieldValues.money) === 0) {
          this.$message.error("请输入大于0的数值");
          return;
        }

        this.showTsConfirm({
          title: "确认信息",
          content: "你确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;

            const res = await this.$store.dispatch("users/frozenmoney", {
              user_id: this.userId,
              field: this.field,
              deposit_cate: this.depositCate,
              type: fieldValues.type,
              money: Big(fieldValues.money)
                .mul(100)
                .toNumber()
              // ...fieldValues,
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }
}
